import { ThemeEvents } from '@theme/events';

const body = document.body;
let cartRevision = 0;

const renderCartCount = (count) => {
  if (!Number.isInteger(count) || count < 0) return;
  document.querySelectorAll('.nps-cart-link').forEach((link) => {
    let badge = link.querySelector('.nps-cart-count');
    if (!badge && count > 0) {
      badge = document.createElement('span');
      badge.className = 'nps-cart-count';
      badge.setAttribute('aria-hidden', 'true');
      link.append(badge);
    }
    if (badge) {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    }
    const label = body.dataset.npsCartLabel;
    if (label) link.setAttribute('aria-label', label.replace('__NPS_COUNT__', String(count)));
  });
};

const fetchCartCount = async (revision) => {
  const cartUrl = body.dataset.npsCartUrl;
  if (!cartUrl) return;
  try {
    const response = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) return;
    const cart = await response.json();
    if (revision === cartRevision) renderCartCount(cart.item_count);
  } catch {}
};

const countFromSections = (sections) => {
  if (!sections) return null;
  for (const html of Object.values(sections)) {
    if (typeof html !== 'string') continue;
    const section = new DOMParser().parseFromString(html, 'text/html');
    const count = section.querySelector('[ref="cartItemCount"]');
    if (count) {
      const value = Number.parseInt(count.textContent, 10);
      if (Number.isInteger(value)) return value;
    }
    if (section.querySelector('cart-items-component .cart-items__empty-button')) return 0;
  }
  return null;
};

document.addEventListener(ThemeEvents.cartUpdate, (event) => {
  const revision = ++cartRevision;
  const { resource, data = {} } = event.detail || {};
  if (data.didError) {
    void fetchCartCount(revision);
    return;
  }
  const sectionCount = countFromSections(data.sections);
  const count = Number.isInteger(resource?.item_count)
    ? resource.item_count
    : sectionCount ?? (data.source !== 'product-form-component' ? data.itemCount : null);
  if (Number.isInteger(count) && count >= 0) renderCartCount(count);
  else void fetchCartCount(revision);
});

window.addEventListener('pageshow', (event) => {
  if (event.persisted) void fetchCartCount(++cartRevision);
});

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.nps-cart-link')) void fetchCartCount(++cartRevision);
});
